module.exports = __webpack_public_path__ + "static/media/versoes.1dc76a34.svg";